var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0 pb-2 pl-1", attrs: { align: "center" } },
        [
          _vm._v(" " + _vm._s(_vm.t("theConditions")) + ": "),
          _c(
            "v-btn",
            {
              staticClass: "ma-0 pa-2 ml-3",
              attrs: {
                width: "auto",
                height: "auto",
                id: "back_clean_btn",
                elevation: "0",
              },
              on: { click: _vm.regionDialogOpen },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { color: "white" },
                  attrs: { align: "center" },
                },
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-2",
                    attrs: {
                      "max-height": "1rem",
                      "max-width": "1rem",
                      src: require("@/assets/images/plus_white.png"),
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.tsc("region")) + " "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticClass: "ma-0 pa-2 ml-3",
              attrs: {
                width: "auto",
                height: "auto",
                id: "back_clean_btn",
                elevation: "0",
              },
              on: { click: _vm.filterDialogOpen },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { color: "white" },
                  attrs: { align: "center" },
                },
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-2",
                    attrs: {
                      "max-height": "1rem",
                      "max-width": "1rem",
                      src: require("@/assets/images/plus_white.png"),
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.t("filtering")) + " "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticClass: "ma-0 pa-2 ml-3",
              attrs: {
                width: "auto",
                height: "auto",
                id: "back_clean_btn",
                elevation: "0",
              },
              on: { click: _vm.tagDialogOpen },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { color: "white" },
                  attrs: { align: "center" },
                },
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0 mr-2",
                    attrs: {
                      "max-height": "1rem",
                      "max-width": "1rem",
                      src: require("@/assets/images/plus_white.png"),
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.t("tag")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "ma-0 pa-0",
          attrs: { cols: "12", id: "noneBorderBox" },
        },
        [
          _vm.areaLoading == false
            ? [
                _vm.storeList.length > 0
                  ? [
                      _c("v-treeview", {
                        attrs: {
                          "selected-color": "blue",
                          selectable: "",
                          dark: "",
                          dense: "",
                          "return-object": "",
                          items: _vm.storeList,
                          "item-key": "id",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "auto" },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          98227188
                        ),
                        model: {
                          value: _vm.selectedCameras,
                          callback: function ($$v) {
                            _vm.selectedCameras = $$v
                          },
                          expression: "selectedCameras",
                        },
                      }),
                    ]
                  : [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-10", attrs: { cols: "12" } },
                        [_vm._v(_vm._s(_vm.t("noData")))]
                      ),
                    ],
              ]
            : [
                _c("v-skeleton-loader", {
                  attrs: {
                    boilerplate: false,
                    elevation: "0",
                    dark: "",
                    type: "list-item-three-line, list-item-two-line, list-item-three-line",
                  },
                }),
              ],
        ],
        2
      ),
      _c("StoreSearchDialog", {
        attrs: {
          dialogVisible: _vm.regionDialogVisible,
          storeData: _vm.allStores,
          preSelectedAreas: _vm.selectedAreas,
        },
        on: {
          visible: _vm.regionDialogVisibleFunc,
          editArea: _vm.editAreaFunc,
        },
      }),
      _c("FilterDialog", {
        attrs: {
          dialogVisible: _vm.filterDialogVisible,
          brandBoxVisible: false,
          filterData: _vm.filteredData,
        },
        on: {
          visible: _vm.filterDialogVisibleFunc,
          filterParams: _vm.filterParamsFunc,
        },
      }),
      _c("TagDialog", {
        attrs: {
          dialogVisible: _vm.tagDialogVisible,
          preselectTagNames: _vm.tagNames,
        },
        on: {
          tagVisible: _vm.tagDialogVisibleFunc,
          tagNames: _vm.tagNamesFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }